<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" />
    </div>
    <div class="content">
      <div class="company">
        <p>Company Details</p>

        <div class="company__div">
          <div class="company__div--content">
            <div class="company__div--content-loader" v-show="pageLoader">
              <PageLoader />
            </div>
            <div class="company__div--content-header" v-show="!pageLoader">
              <div class="company__div--content-header-details">
                <div class="company__div--content-header-details-name">
                  {{
                    companydetails.trading_name
                      ? companydetails.trading_name
                      : "not available"
                  }}
                </div>
              </div>
              <div class="company__div--content-header-edit">
                <span @click="showCompanySetting">
                  <font-awesome-icon icon="edit" />&nbsp;edit information
                </span>
              </div>
            </div>
            <div class="company__div--content-body" v-show="!pageLoader">
              <div class="company__div--content-body-table">
                <table>
                  <tbody>
                    <tr>
                      <td>Company Name:</td>
                      <td>
                        {{
                          companydetails.trading_name
                            ? companydetails.trading_name
                            : "not available"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Company Website:</td>
                      <td>
                        <a
                          :href="`//${companydetails.website}`"
                          target="_blank"
                          >{{
                            companydetails.website
                              ? companydetails.website
                              : "not available"
                          }}</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>Tax ID Number:</td>
                      <td>
                        {{
                          companydetails.tax_number
                            ? companydetails.tax_number
                            : "not available"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Registration Number:</td>
                      <td>
                        {{
                          companydetails.registration_number
                            ? companydetails.registration_number
                            : "not available"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Country:</td>
                      <td>
                        {{
                          companydetails.country
                            ? companydetails.country.name
                            : "not available"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>State:</td>
                      <td>
                        {{
                          companydetails.state
                            ? companydetails.state.name
                            : "not available"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>City:</td>
                      <td>
                        {{
                          companydetails.city
                            ? companydetails.city
                            : "not available"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Address:</td>
                      <td>
                        {{
                          companydetails.address ? companydetails.address : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Email:</td>
                      <td>
                        {{
                          companydetails.email
                            ? companydetails.email
                            : "not available"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Phone:</td>
                      <td>
                        {{
                          companydetails.phone
                            ? companydetails.phone
                            : "not available"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Industry:</td>
                      <td>
                        {{
                          companydetails.industry
                            ? companydetails.industry.name
                            : "not available"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";

export default {
  name: "CompanyDetails",
  components: {
    Header,
    Sidebar,
    PageLoader,
  },
  data() {
    return {
      item: "companydetails",
      companydetails: {},
      pageLoader: true,
    };
  },
  metaInfo: {
    title: 'Company Details - hrdesk',
    meta: [
      { name: 'description', content: 'Learn more about hrdesk, our mission, values, and achievements.' },
      { property: 'og:title', content: 'Company Details - hrdesk' },
      { property: 'og:description', content: 'Learn more about hrdesk, our mission, values, and achievements.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/company-details' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Company Details - hrdesk' },
      { name: 'twitter:description', content: 'Learn more about hrdesk, our mission, values, and achievements.' },
      { name: 'twitter:image:alt', content: 'Company Details at hrdesk' },
    ]
  },
  methods: {
    showCompanySetting() {
      this.$store.showCompanySetting = "company";
      this.$router.push("/settings");
    },
  },
  created() {
    this.pageLoader = true;
    const companyId = this.$store.getters.currentAuthUser.employees.company_id;
    this.$http
      .get(`${types.COMPANY_GET_API}/${companyId}`)
      .then((resp) => {
        this.companydetails = resp.data.data;
        this.pageLoader = false;
      })
      .catch(() => {
        this.pageLoader = true;
      });
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

  .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
    margin-top: 2rem;
    background: #fbfafa;
    margin-left: 200px;
    height: 100vh;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
      padding: 0;
    }
  }
}
.company {
  padding-top: 3rem;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  > p {
    font-size: 1.5rem;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.18;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    margin: 0;
  }

  > .company__div {
    border-top: 1px solid #caced5;
    padding: 0 5px;

    > .company__div--content {
      margin-top: 30px;
      margin-bottom: 100px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      padding: 2rem 1.5rem;

      > .company__div--content-loader {
        > div {
          width: 55px;
          margin: 0 auto;
        }
      }

      > .company__div--content-header {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        > .company__div--content-header-details {
          width: 70%;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          > .company__div--content-header-details-logo {
            width: 100px;
            border-radius: 60px;
            overflow: hidden;
          }

          > .company__div--content-header-details-name {
            padding-left: 30px;
            font-size: 1.5rem;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.18;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media (max-width: 768px) {
              padding-left: 0.5rem;
              font-weight: 700;
            }
          }
        }

        > .company__div--content-header-edit {
          width: 30%;
          font-size: 1rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.88;
          letter-spacing: 0.48px;
          text-align: center;
          color: #f17d6b;
          cursor: pointer;

          > a {
            color: #f17d6b;
            text-decoration: none;
          }
        }
      }

      > .company__div--content-body {
        margin-top: 50px;
        padding: 0 30px;
        @media (max-width: 768px) {
          padding: 0.5rem;
        }

        > .company__div--content-body-table {
          > table {
            > tbody {
              > tr {
                > td:nth-child(1) {
                  width: 30%;
                  font-size: 1rem;
                  font-weight: normal;
                  font-style: normal;
                  font-stretch: normal;
                  line-height: 1.25;
                  letter-spacing: 0.72px;
                  text-align: left;
                  color: #000000;
                  padding-bottom: 30px;
                  padding-right: 0.5rem;
                }

                > td:nth-child(2) {
                  width: 70%;
                  font-size: 1rem;
                  font-weight: normal;
                  font-style: normal;
                  font-stretch: normal;
                  line-height: 1.25;
                  letter-spacing: 0.72px;
                  text-align: left;
                  color: #000000;
                  padding-bottom: 30px;
                  word-break: break-all;

                  > a {
                    text-decoration: underline;
                    color: #000000;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

